import { buildShareUrl, type ContentNugget } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';

const GROW_URL = process.env.REACT_APP_GROW_URL ?? '';

type GetShareUrlParams = Readonly<{
  contentNugget: ContentNugget;
  growUrl?: string;
}>;

export const getShareUrl = ({ contentNugget, growUrl = GROW_URL }: GetShareUrlParams): string =>
  buildShareUrl({ contentNugget, growUrl, appRoute: APP_ROUTE });
